import React from "react";
import { Modal, ModalBody } from "reactstrap";

const FeatureRequestConfirmDeleteModal = ({
  isOpen,
  record,
  onCancel,
  onConfirm,
  isDeleting,
}) => {
  if (!record) {
    return null;
  }

  return (
    <Modal isOpen={isOpen} toggle={onCancel} centered className="fr-delete-modal">
      <ModalBody>
        <div className="rd_modalvieew">
          <div className="box_content rd_modalboxcontent">
            <div className="rd_inputselectheadermodalsetting">
              <button
                type="button"
                className="rd_colsebtn"
                onClick={onCancel}
                aria-label="Close"
              />
            </div>

            <h5 className="rd_modalheadertext rd_modalheadertextnm">
              Delete idea?
            </h5>

            <p className="rd_modalheadertextparath mt-4 mb-2">
              Are you sure you want to permanently delete this idea?
            </p>
            <p className="fr-delete-modal__title">"{record.title}"</p>
            <p className="fr-delete-modal__hint">
              This action cannot be undone.
            </p>

            <div className="rd_cancelappbtnmodal">
              <button
                type="button"
                className="btn btn-outline"
                onClick={onCancel}
                disabled={isDeleting}
              >
                Cancel
              </button>
              <button
                type="button"
                className="btn btn-app fr-delete-modal__confirm"
                disabled={isDeleting}
                onClick={onConfirm}
              >
                {isDeleting ? "Deleting..." : "Delete"}
              </button>
            </div>
          </div>
        </div>
      </ModalBody>
    </Modal>
  );
};

export default FeatureRequestConfirmDeleteModal;
